import { HttpClient } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { environment } from 'src/environments/environment';
import { CommonService } from '../../common-service';
import { ListRoomResponse } from '../../responses/flow/list-room.response';

@Injectable({
  providedIn: 'root'
})
export class NoModuleRoomService extends CommonService{

  constructor(private router: Router, private httpClient: HttpClient) {
    super();
  }

  public listRoom(): Observable<ListRoomResponse> {
    
    let uri = `NoModuleRoom`
      
    return this.httpClient.get<ListRoomResponse>(environment.urlApiFlow + uri, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }
}
